// document.addEventListener("turbolinks:load", function () {
var stripeApi
    function initialize_stripe_account(publish_key){
        stripeApi = Stripe(publish_key);

        var $bankform = $('#bank-account-form');
        $("#bank-account-submit").on("click", function (event) {
            // Clear any errors
            if ($bankform.valid()) {
                $bankform.find('.has-error').removeClass('has-error');
                // Disable the submit button to prevent repeated clicks:
                // $bankform.find('.submit').prop('disabled', true).html("<i class='fa fa-spinner fa-spin'></i> Creating account...");
                $bankform.find('.btn-bank').prop('disabled', true).html("<i class='fa fa-spinner fa-spin'></i> Saving...");

                // Stripe.bankAccount.createToken($bankform, stripeResponseHandler);

                var ssn = $("#stripe_ssn").val();
                var data = {
                    business_type: "individual",
                    individual: {
                        phone: $("#stripe_phone").val(),
                        email: $("#stripe_email").val(),
                        address: {
                            city: $("#stripe_city").val(),
                            state: $("#stripe_state").val(),
                            country: $("#stripe_country").val(),
                            postal_code: $("#stripe_postal_code").val(),
                            line1: $("#stripe_apartment_no").val() + " " + $("#stripe_address_line_1").val(),
                            line2: $("#stripe_address_line_2").val()
                        },
                        first_name: $("#stripe_first_name").val(),
                        last_name: $("#stripe_last_name").val(),
                        dob: {
                            month: $("#stripe_dob").val().split('-')[0],
                            day: $("#stripe_dob").val().split('-')[1],
                            year: $("#stripe_dob").val().split('-')[2]
                        },
                        ssn_last_4: ssn
                    },
                    tos_shown_and_accepted: true
                }

                stripeToken({
                    data: data,
                    success: function(token) {
                        // $('#stripe_account_form_token').val(token.id);
                        $bankform.append($('<input type="hidden" name="stripeToken" />').val(token.id));
                        $bankform.get(0).submit();
                    },
                    error: function(error) {
                        console.log('Stripe token error ="' + error.message + '" "' + error.param + '" "' + error.type + '"');

                        $bankform.find('.errors').text('Stripe token error ="' + error.message + '" "' + error.param + '" "' + error.type + '"').addClass('text-danger');
                        $bankform.find('.' + error.param).parent('.form-group').addClass('has-error');
                        $bankform.find('button').prop('disabled', false).text('Add bank account'); // Re-enable submission
                    },
                    verify: false,
                    fileCallback: function(fileData) {
                        var verification = {
                            verification: {
                                document: {
                                    front: fileData.id,
                                }
                            }
                        };
                        $.extend(data.individual, verification);
                    }
                });



                // Prevent the form from being submitted:
                return false;
            }
        });
    }
// });





//////////////////////////////////////////////////////////////////////
// compiled by http://babeljs.io/repl/ from stripe_token_original2.js
//////////////////////////////////////////////////////////////////////
/* jshint ignore:start */
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var omitNullDeep = function(obj) {
    return _.reduce(obj, function(result, value, key) {
        if (_.isObject(value)) {
            result[key] = omitNullDeep(value);
        }
        else if (!_.isNull(value)) {
            result[key] = value;
        }
        return result;
    }, {});
};


// contains async-await
var stripeToken =
    /*#__PURE__*/
    function () {
        var _ref = _asyncToGenerator(
            /*#__PURE__*/
            regeneratorRuntime.mark(function _callee(options) {
                var fileForm, fileResult, fileData, result;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!options.verify) {
                                    _context.next = 11;
                                    break;
                                }

                                fileForm = new FormData();
                                fileForm.append('file', options.fileElement);
                                fileForm.append('purpose', 'identity_document');
                                _context.next = 6;
                                return fetch('https://uploads.stripe.com/v1/files', {
                                    method: 'POST',
                                    headers: {
                                        'Authorization': 'Bearer ' + stripeApi._apiKey
                                    },
                                    body: fileForm
                                });

                            case 6:
                                fileResult = _context.sent;
                                _context.next = 9;
                                return fileResult.json();

                            case 9:
                                fileData = _context.sent;

                                if (fileData.id) {
                                    options.fileCallback(fileData);
                                }

                            case 11:
                                _context.next = 13;
                                return stripeApi.createToken('account', omitNullDeep(options.data));

                            case 13:
                                result = _context.sent;

                                if (result.token) {
                                    options.success(result.token);
                                }

                                if (result.error) {
                                    options.error(result.error);
                                }

                            case 16:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee);
            }));

        return function stripeToken(_x) {
            return _ref.apply(this, arguments);
        };
    }();
/* jshint ignore:end */


export default initialize_stripe_account;